export default "__VITE_ASSET__j2_qlPJO__"